import * as React from 'react';
import * as axios from 'axios';
import injectSheet from 'react-jss';
import { Button, Select, Icon, Spin, Form, Tabs, Badge, Tooltip } from 'antd';
import { MIN_WIDTH } from 'src/globals';
import SimplePaginator from 'src/components/common/SimplePaginator';
import InquiryFFCard from './Cards/InquiryFFCard';
import InquiryFilterPopup from './Popups/InquiryFilterPopup';
import InquirySortPopup from './Popups/InquirySortPopup';
import {
  setFilters,
  applyFilters,
  resetFilters,
  setPagination,
  resetPagination,
  setPrevPagination,
} from 'src/actions/InquiryFFAction';
import { bindActionCreators } from 'redux';
import SortIcon from 'src/components/common/icons/SortIcon';
import { connect } from 'react-redux';
import Loader from 'src/components/common/Loader';
import {
  searchInquiryForFFApi,
} from 'src/api/inquiry';
import LightHouseIcon from 'src/components/common/icons/LightHouseIcon';
import withInquiryMasterData from './hoc/InitInquiryMaster';
import withAuthAccessExim from 'src/components/hoc/withAuthAccessExim';
import { INQUIRY_FF } from 'src/utils/partsToShow/partsConstants';
import InquiryModes from './InquiryModes';
import UploadBidsFilterModal from './Modals/UploadBidsFilterModal';
import { sendEvent, EventCategories } from 'src/utils/gaService';
import { getInquiryFFRoute } from 'src/routing/utils';
import { isValidArray } from 'src/Library/Helper';
import BulkRequestProgressPopup from '../../common/BulkRequestProgressPopup';
import { REQUEST_STATUS } from '../BulkRequest/BulkRequestUtils';
import { INQUIRY_AUTO_REFRESH_INTERVAL_FF } from './constants';
import { tokens } from 'src/design-system';

const styles = (theme: any) => ({
  outerBox: {
    display: 'flex',
    flexDirection: 'column',
    padding: '13px 24px',
    paddingBottom: '0px',
  },
  innerBox: {
    display: 'flex',
  },
  toolbarWhite: {
    display: 'flex',
    background: tokens.colors.bgWhite,
    paddingTop: '12px',
    paddingBottom: '1px',
    marginBottom: 2,
    borderRadius: tokens.radius.sm,
    borderTopLeftRadius: '0px',
    justifyContent: 'space-between',
    border: '1px solid #D9D9D9',
    borderTop: 'none',
    width: '100%'
  },
  selectSearchStyle: {
    cursor: '',
    width: '124px',
    marginLeft: '15px',
    fontSize: '13px',
    '& .ant-select-selection': {
      borderRadius: '4px 0 0 4px',
    },
  },
  search: {
    '& .ant-select-selection--multiple .ant-select-selection__clear': {
      marginRight: '10px',
      borderRadius: '0 4px 4px 0',
      height: '100%',
      overflowY: 'scroll',
    },
    width: '158px',
    height: '30px',
    '& .ant-select-selection__placeholder': {
      fontSize: '13px !important',
    },
  },
  innerToolBarWhite: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    background: tokens.colors.bgWhite,
  },
  typeStyle: {
    borderRadius: '0',
    // borderLeftWidth: '0.5px',
    // borderRightWidth: '0.5px',
    borderColor: '#d9d9d9',
    color: null,
  },
  typeFilterSelected: {
    color: tokens.colors.primary,
    borderRadius: '0',
  },
  bottomButtons: {
    bottom: 30,
  },
  notFound: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  errorBlock: {
    margin: '15px',
  },
  uploadBidsButton: {
    backgroundColor: 'rgb(24, 144, 255)',
    border: '1px solid rgb(24, 144, 255)',
    color: tokens.colors.bgWhite,
    '&:hover': {
      backgroundColor: 'rgb(24, 144, 255)',
      border: '1px solid rgb(24, 144, 255)',
      color: tokens.colors.bgWhite,
    },
    '&:focus': {
      backgroundColor: 'rgb(24, 144, 255)',
      border: '1px solid rgb(24, 144, 255)',
      color: tokens.colors.bgWhite,
    },
  },
});

const filters = [{
  data_key: 'all',
  label: 'All',
  color: '#030852',
}, {
  data_key: 'open',
  label: 'Open',
  color: '#096dd9',
}, {
  data_key: 'closed',
  label: 'Closed',
  color: '#cf1322',
}, {
  data_key: 'confirmed',
  label: 'Confirmed',
  color: '#52c41a',
}, {
  data_key: 'rejected',
  label: 'Rejected',
  color: '#F69FA0',
}];

interface State {
  typeFilter: string,
  isSearching: boolean,
  popupVisible: boolean,
  sortVisible: boolean,
  clearVisible: boolean,
  dropdown: Array<any>,
  isUploadBidsFilterVisible: boolean,
  uploadRequest: undefined | {
    fileName: string,
    id: string | number,
    status: REQUEST_STATUS,
  }
};

class RFQEnquiryFF extends React.PureComponent<any, State> {

  currentRequestId = 0;

  currentCancelToken: {
    cancel: (message: string) => void;
    token: any;
  } | null = null;

  state = {
    typeFilter: 'ALL',
    isSearching: true,
    popupVisible: false,
    sortVisible: false,
    clearVisible: false,
    dropdown: [],
    isUploadBidsFilterVisible: false,
    uploadRequest: undefined
  };

  // interval for handling auto Refresh
  interval: NodeJS.Timeout;

  componentDidMount() {
    const {
      location,
      setFilters,
      appliedFilters,
      resetFilters,
      shouldResetFilters,
      statusFilter,
    } = this.props;
    const searchArray = location?.search?.replace('?modeList=', '');
    if (searchArray) {
      setFilters({ modeList: searchArray?.toUpperCase()?.split(',') }, true);
    } else if (!searchArray && isValidArray(appliedFilters?.modeList)) {
      shouldResetFilters && resetFilters(false);
      setFilters({ modeList: [] }, true);
    } else if (!statusFilter) {
      if (shouldResetFilters) {
        resetFilters(false);
        this.setStatusFilter({ status: appliedFilters.status, modeList: [] });
      } else {
        this.handleReload();
      }
    } else {
      shouldResetFilters && resetFilters(false);
      this.setStatusFilter({ status: statusFilter, modeList: [] });
    }
    this.interval = setInterval(() => this.props.setPrevPagination(), INQUIRY_AUTO_REFRESH_INTERVAL_FF);
  }

  componentWillUnmount(){
    clearInterval(this.interval);
  }
  
  setStatusFilter = (filters) => {
    this.props.setFilters(filters);
    this.props.applyFilters();
  }

  popupFunc = (popup) => {
    if (popup === true) {
      return <InquiryFilterPopup closeFilter={this.closeFilter}
        loading={this.props.isLoading}
        handleCancel={this.handleCancel} handleApply={this.handleApply} />;
    }
    return <div></div>;
  }

  handleApply = () => {
    this.props.applyFilters();
    this.setState({
      popupVisible: false,
    });
  }

  handleReload = () => {
    this.props.setPrevPagination();
    this.closeFilter();
  }

  handleCancel = () => {
    this.props.setFilters({
      polList: this.props.appliedFilters.polList,
      podList: this.props.appliedFilters.podList,
      typeList: this.props.appliedFilters.typeList,
      modeList: this.props.appliedFilters.modeList,
      shipperList: this.props.appliedFilters.shipperList,
    });
    this.setState({
      popupVisible: false,
    });
  }

  clearFilters = () => {
    this.props.resetFilters();
    this.setState({
      popupVisible: false,
    });
  }

  handleFilterClick = () => {
    this.props.setFilters({
      polList: this.props.appliedFilters.polList,
      podList: this.props.appliedFilters.podList,
      typeList: this.props.appliedFilters.typeList,
      shipperList: this.props.appliedFilters.shipperList,
    });
    this.setState({
      popupVisible: !this.state.popupVisible,
      sortVisible: false,
    });
  }

  handleSortClick = () => {
    this.setState({
      sortVisible: !this.state.sortVisible,
      popupVisible: false,
    });
  }

  closeFilter = () => {
    this.setState({
      popupVisible: false,
      sortVisible: false,
    });
  }

  handlePaginationClick = (nextOrPrev) => {
    this.props.setPagination({
      nextOrPrev,
      lastInquiryId: nextOrPrev === 'prev' ?
        this.props.pagination.lastItemIdPrev : this.props.pagination.lastItemIdNext,
      lastSortedColumnValue: nextOrPrev === 'prev' ?
        this.props.pagination.lastSortedColumnValuePrev :
        this.props.pagination.lastSortedColumnValueNext,
    });
  }

  handleFirstPageClick = () => {
    this.props.resetPagination();
  }

  searchInquiry = async (search) => {
    this.currentRequestId += 1;
    const requestId = this.currentRequestId;
  
    if (this.currentCancelToken) {
      this.currentCancelToken.cancel('Operation canceled due to new request.');
    }

    this.currentCancelToken = axios.default.CancelToken.source();

    if (!this.state.isSearching) {
      this.setState({
        isSearching: true,
      });
    }
    const response: any = await searchInquiryForFFApi({ 
      inquiryString: search ? search.trim() : search,
    }, this.currentCancelToken);

    if (requestId === this.currentRequestId) {
      if (response.isSuccess) {
        this.setState({
          isSearching: false,
          dropdown: response.response,
        });
      }
    }
  }

  timeout: any = null;

  handleInquirySearch = (val) => {
    if (val.length) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.setState({
        isSearching: true,
      });
      this.timeout = setTimeout(() => {
        this.searchInquiry(val);
      }, 200);
    } else {
      this.timeout && clearTimeout(this.timeout);
      this.setState({ dropdown: [] });
    }
  }

  handleInquiryChange = (search, option) => {
    const { applyFilters, setFilters } = this.props;
    setFilters({
      inquiryIdList: search ? [search.key] : [],
      inquirySearched: search || [],
    });
    applyFilters();
  }

  renderNoData = () => {
    const { classes, theme } = this.props;
    return (<div className={classes.notFound}>
      <div style={{
        display: 'flex', alignItems: 'center',
        flexDirection: 'column', marginTop: '8%',
      }}>
        <div className={classes.notFoundItems}>
          <LightHouseIcon className={classes.blackIcon}
            width="184" height="184"></LightHouseIcon></div>
        <div className={classes.notFoundItems}
          style={{ fontWeight: tokens.fontWeight.semibold, fontSize: 16 }}>
          No inquiries to show.</div>
        <div className={classes.notFoundItems}
          style={{ paddingTop: 10, fontSize: 14 }}>
          To get more results, or try adjusting your filters.</div>
      </div>
    </div>);
  }

  FilterToolbar = (props: any) => {
    const { classes, pagination, setPagination, appliedFilters, totalCnt } = props;
    const { isSearching, dropdown, clearVisible } = this.state;
    return (
      <div className={classes.toolbarWhite}>
        <div style={{
          display: 'flex', marginTop: '8px',
          flexDirection: 'row', paddingLeft: 16,
        }}>
          <div style={{ display: 'flex', marginTop: '-6px' }}>
            <Select
              showSearch
              allowClear
              labelInValue
              dropdownMatchSelectWidth={false}
              value={appliedFilters.inquirySearched}
              filterOption={(inputValue, option) => true}
              notFoundContent={isSearching ? <div style={{ padding: '25px' }}>
                <Spin style={{ marginLeft: '45%' }} /></div> :
                'Not Found'}
              suffixIcon={<Icon type="search" />}
              className={classes.search}
              placeholder={'Search Inquiry'}
              onFocus={() => this.searchInquiry('')}
              onChange={this.handleInquiryChange}
              onSearch={this.handleInquirySearch}
              optionLabelProp={'data-value'}
            >
              {dropdown && dropdown.map((item: any) =>
                (<Select.Option key={item.id} data-value={item.referenceNumber}>
                  {item.referenceNumber}
                </Select.Option>))
              }
            </Select>
          </div>
          <InquiryModes appliedFilters={this.props.appliedFilters}
            setFilter={modeList => {
              this.props.setFilters({ modeList });
              this.props.history.push(getInquiryFFRoute(isValidArray(modeList) ? `modeList=${modeList}` : ''));
            }}/>
          <div style={{
            marginLeft: '15px',
            width: '91px', height: '37px', cursor: 'pointer',
            display: 'flex', marginTop: '-1px',
          }} onClick={this.handleFilterClick}>
            <Icon type="filter" style={{
              height: '14px', width: '14px',
              marginTop: '3px',
              color: (totalCnt === 0 ? '#424242' : tokens.colors.primary),
            }} theme={totalCnt ? 'filled' : 'outlined'} />
            <span style={{
              fontFamily: 'Open Sans',
              paddingLeft: '10px',
            }} >Filters</span>
            {totalCnt > 0 ? <span style={{ marginLeft: '8px', fontWeight: 600 }}>
              ({totalCnt})</span> : <span></span>}
          </div>
          <div style={{
            marginLeft: '20px', display: 'flex',
            width: '135px', height: '37px', cursor: 'pointer',
            marginTop: '-2px',
          }} onClick={this.handleSortClick}>
            <SortIcon style={{
              height: '14px', width: '14px', marginTop: '5px',
            }} />
            <span style={{
              fontFamily: 'Open Sans',
              paddingLeft: '10px',
            }}>Sort By</span>
          </div>
          {clearVisible ? <div style={{
            width: '25%', height: '37px', display: 'flex',
            marginLeft: '32px', cursor: 'pointer',
          }} onClick={this.clearFilters}>
            <span style={{ color: tokens.colors.primary, cursor: 'pointer', fontWeight: 600 }}>
              Clear Filters</span>
          </div> : <div />}
        </div>
        <div style={{
          marginTop: '2px', display: 'flex',
          flexDirection: 'row', marginRight: '2%',
        }}>
          <div style={{
            display: 'flex',
          }} >
            <Tooltip title="Reload">
              <Button icon="reload" disabled={this.props.isLoading}
                onClick={this.handleReload}
              ></Button>
            </Tooltip>
          </div>
          <div style={{ display: 'flex', marginLeft: '7%' }} >
            <SimplePaginator
              loading={this.props.isLoading}
              isNext={pagination.isNextPresent ? pagination.isNextPresent : false}
              onFirstClick={this.handleFirstPageClick}
              onPrevClick={() => this.handlePaginationClick('prev')}
              onNextClick={() => this.handlePaginationClick('next')}
              pageNumber={pagination.currentPageNumber}
            />
            <div style={{ margin: '0px 16px' }}>
              <Select value={`${pagination.resultPerPage} / page`}
                disabled={this.props.isLoading}
                onChange={(resultPerPage) => {
                  if (resultPerPage !== pagination.resultPerPage) {
                    setPagination({ resultPerPage });
                  }
                }}>
                <Select.Option key={'10'}> 10 / page</Select.Option>
                <Select.Option key={'25'}> 25 / page</Select.Option>
                <Select.Option key={'50'}> 50 / page</Select.Option>
                <Select.Option key={'100'}>100 / page</Select.Option>
              </Select>
            </div>
          </div>
        </div>
        <UploadBidsFilterModal
        visible={this.state.isUploadBidsFilterVisible}
        handleCancel={() => this.setState({ isUploadBidsFilterVisible: false })}
        handleOk={() => this.setState({ isUploadBidsFilterVisible: false })}
        getRequestObject = {(request) => this.bulkProgressPopupNewRequestUpdate(request)}
        />
        <BulkRequestProgressPopup
        newRequest={this.state.uploadRequest}
        reloadShipments={() => {this.clearFilters(); this.handleReload();}}
        />
      </div>
    );
  }

  bulkProgressPopupNewRequestUpdate(params:{
    fileName: string,
    id: string | number,
    status: REQUEST_STATUS,
  }){
    this.setState({
      uploadRequest: params
    })
  }

  render() {
    const defaultSortBy = {
      status: 'ALL',
      sortBy: 'received_date',
      descendingOrder: true,
    };
    const { classes, appliedFilters, isLoading, data, statusWiseInquiryCount,
      showBidBulkUpload } = this.props;
    const { popupVisible, sortVisible } = this.state;
    const polApplied = appliedFilters.polList && appliedFilters.polList.length > 0 ? 1 : 0;
    const podApplied = appliedFilters.podList && appliedFilters.podList.length > 0 ? 1 : 0;
    const typeApplied = appliedFilters.typeList && appliedFilters.typeList.length > 0 ? 1 : 0;
    const modeApplied = appliedFilters.modeList && appliedFilters.modeList.length > 0 ? 1 : 0;
    const shipperApplied = appliedFilters.shipperList &&
      appliedFilters.shipperList.length > 0 ? 1 : 0;
    const destinationCountry = (appliedFilters.destinationCountryList &&
      appliedFilters.destinationCountryList.length > 0) ? 1 : 0;
    const originCountry = (appliedFilters.originCountryList &&
      appliedFilters.originCountryList.length > 0) ? 1 : 0;
    const internalReferenceNumber = (appliedFilters.internalReferenceNumberList &&
      appliedFilters.internalReferenceNumberList.length > 0) ? 1 : 0;
    const totalCnt = polApplied + podApplied + typeApplied + shipperApplied + destinationCountry +
      originCountry + internalReferenceNumber;
    const sortByOrderChanged = !(
      defaultSortBy.sortBy === appliedFilters.sortBy &&
      defaultSortBy.descendingOrder === appliedFilters.descendingOrder &&
      defaultSortBy.status === appliedFilters.status
      );
    totalCnt > 0 || sortByOrderChanged ?
      this.setState({ clearVisible: true }) : this.setState({ clearVisible: false });
    const activeTabKey = filters.findIndex((item) => {
      return item.data_key === appliedFilters.status.toLowerCase();
    });

    return <div style={{ minWidth: MIN_WIDTH, paddingBottom: '6%' }}>
      <div className={classes.outerBox}>
        <div style={{
          // display: 'flex',
          // // marginBottom: '10px',
          // justifyContent: 'space-between',
        }}>
          <div style={{
            // display: 'flex',
          }}>
            <Tabs type="card"
              activeKey={activeTabKey.toString()}
              tabBarGutter={-1}
              tabBarStyle={{ marginBottom: '0px' }}
              onChange={(key) => {
                const element = filters[parseInt(key, 10)];
                this.setStatusFilter({ status: element.label.toUpperCase() });
                this.setState({ popupVisible: false });
              }}
              tabBarExtraContent={
                showBidBulkUpload && <Button className={classes.uploadBidsButton}
                onClick={() => {
                  this.setState({ isUploadBidsFilterVisible: true });
                  sendEvent(
                    EventCategories.INQUIRY_BIDDING,
                    'Upload Bids',
                  );
                }}>
                Upload Bids
                </Button>
              }>
                {filters.map((element, ind) => {
                  return (
                    <Tabs.TabPane
                      disabled={isLoading}
                      tab={
                        <span style={{ display:'flex' }}>
                          { element.label === 'Rejected' ? 'Declined':element.label}
                          <div
                            style={{
                              color: 'white', marginLeft: '7px',
                            }}>
                            {!isLoading && statusWiseInquiryCount
                              ? <Tooltip title={statusWiseInquiryCount[element.data_key]}>
                                <Badge count={statusWiseInquiryCount[element.data_key]}
                                style={{ backgroundColor: element.color }} title=" "
                                showZero />
                              </Tooltip> :
                              <span className={'loadingDotsBlue'}></span>}
                          </div>
                        </span>
                      }
                      key={ind.toString()}>
                        <this.FilterToolbar {...this.props} totalCnt={totalCnt}/>
                      </Tabs.TabPane>
                  );
                })}
              </Tabs>
          </div>
        </div>
        <div style={{ position: 'relative' }}>
          {this.popupFunc(popupVisible)}
          {sortVisible ? <InquirySortPopup closeFilter={this.closeFilter}
            loading={this.props.isLoading} /> : <div />}
        </div>
      </div>
      {
        isLoading && <div style={{ height: '100%' }}>
          <Loader style={{position: 'fixed'}} zIndex={2} backgroundColor='rgb(255, 255, 255, 0.5)'/>
        </div> 
      }
      <div style={{ margin: '0 16px' }}>
          {
            data && data.length !== 0 ? data.map(el => <InquiryFFCard cardData={el} key={el.id}
              handleReload={() => this.handleReload()} />)
              : this.renderNoData()
          }
      </div>
    </div>;
  }
}
const mapStateToProps = ({ masterData, inquiryFFReducer }, ownProps) => ({
  appliedFilters: inquiryFFReducer.appliedFilters,
  pagination: inquiryFFReducer.pagination,
  isLoading: inquiryFFReducer.isLoading,
  data: inquiryFFReducer.data,
  statusWiseInquiryCount: inquiryFFReducer.statusWiseInquiryCount,
  showBidBulkUpload: masterData.modules.show_bid_bulk_upload,
});
const mapDispatchToProps = dispatch => (bindActionCreators({
  setFilters,
  applyFilters,
  resetFilters,
  setPagination,
  setPrevPagination,
  resetPagination,
}, dispatch));
const RFQEnquiryFFStyled = injectSheet(styles)(RFQEnquiryFF);
export default withInquiryMasterData(connect(mapStateToProps,
  mapDispatchToProps)(Form.create()(withAuthAccessExim([INQUIRY_FF])(RFQEnquiryFFStyled))));
